// eslint-disable-next-line no-shadow
export enum HubriseLocale {
    // Anglais
    EN_US = 'en-US', // Anglais (États-Unis)
    EN_GB = 'en-GB', // Anglais (Royaume-Uni)
    EN_CA = 'en-CA', // Anglais (Canada)
    EN_AU = 'en-AU', // Anglais (Australie)
    EN_NZ = 'en-NZ', // Anglais (Nouvelle-Zélande)
    EN_ZA = 'en-ZA', // Anglais (Afrique du Sud)

    // Français
    FR_FR = 'fr-FR', // Français (France)
    FR_CA = 'fr-CA', // Français (Canada)
    FR_BE = 'fr-BE', // Français (Belgique)
    FR_CH = 'fr-CH', // Français (Suisse)

    // Espagnol
    ES_ES = 'es-ES', // Espagnol (Espagne)
    ES_MX = 'es-MX', // Espagnol (Mexique)
    ES_AR = 'es-AR', // Espagnol (Argentine)
    ES_CO = 'es-CO', // Espagnol (Colombie)
    ES_CL = 'es-CL', // Espagnol (Chili)

    // Allemand
    DE_DE = 'de-DE', // Allemand (Allemagne)
    DE_AT = 'de-AT', // Allemand (Autriche)
    DE_CH = 'de-CH', // Allemand (Suisse)

    // Italien
    IT_IT = 'it-IT', // Italien (Italie)
    IT_CH = 'it-CH', // Italien (Suisse)

    // Portugais
    PT_PT = 'pt-PT', // Portugais (Portugal)
    PT_BR = 'pt-BR', // Portugais (Brésil)

    // Néerlandais
    NL_NL = 'nl-NL', // Néerlandais (Pays-Bas)
    NL_BE = 'nl-BE', // Néerlandais (Belgique)

    // Langues nordiques
    SV_SE = 'sv-SE', // Suédois (Suède)
    NO_NO = 'no-NO', // Norvégien (Norvège)
    DA_DK = 'da-DK', // Danois (Danemark)
    FI_FI = 'fi-FI', // Finnois (Finlande)
    IS_IS = 'is-IS', // Islandais (Islande)

    // Langues slaves
    RU_RU = 'ru-RU', // Russe (Russie)
    PL_PL = 'pl-PL', // Polonais (Pologne)
    CS_CZ = 'cs-CZ', // Tchèque (République tchèque)
    SK_SK = 'sk-SK', // Slovaque (Slovaquie)
    HR_HR = 'hr-HR', // Croate (Croatie)
    SR_RS = 'sr-RS', // Serbe (Serbie)
    BG_BG = 'bg-BG', // Bulgare (Bulgarie)
    UK_UA = 'uk-UA', // Ukrainien (Ukraine)

    // Langues asiatiques
    JA_JP = 'ja-JP', // Japonais (Japon)
    KO_KR = 'ko-KR', // Coréen (Corée du Sud)
    ZH_CN = 'zh-CN', // Chinois simplifié (Chine)
    ZH_TW = 'zh-TW', // Chinois traditionnel (Taïwan)
    ZH_HK = 'zh-HK', // Chinois traditionnel (Hong Kong)
    TH_TH = 'th-TH', // Thaï (Thaïlande)
    VI_VN = 'vi-VN', // Vietnamien (Vietnam)
    ID_ID = 'id-ID', // Indonésien (Indonésie)
    MS_MY = 'ms-MY', // Malais (Malaisie)

    // Langues du Moyen-Orient
    AR_SA = 'ar-SA', // Arabe (Arabie saoudite)
    AR_EG = 'ar-EG', // Arabe (Égypte)
    AR_AE = 'ar-AE', // Arabe (Émirats arabes unis)
    HE_IL = 'he-IL', // Hébreu (Israël)
    FA_IR = 'fa-IR', // Persan (Iran)
    TR_TR = 'tr-TR', // Turc (Turquie)

    // Langues indiennes
    HI_IN = 'hi-IN', // Hindi (Inde)
    BN_BD = 'bn-BD', // Bengali (Bangladesh)
    TA_IN = 'ta-IN', // Tamoul (Inde)
    TE_IN = 'te-IN', // Telugu (Inde)
    UR_PK = 'ur-PK', // Ourdou (Pakistan)

    // Autres langues européennes
    EL_GR = 'el-GR', // Grec (Grèce)
    HU_HU = 'hu-HU', // Hongrois (Hongrie)
    RO_RO = 'ro-RO', // Roumain (Roumanie)
    LT_LT = 'lt-LT', // Lituanien (Lituanie)
    LV_LV = 'lv-LV', // Letton (Lettonie)
    ET_EE = 'et-EE', // Estonien (Estonie)
    SL_SI = 'sl-SI', // Slovène (Slovénie)
    MT_MT = 'mt-MT', // Maltais (Malte)

    // Langues africaines
    SW_KE = 'sw-KE', // Swahili (Kenya)
    AF_ZA = 'af-ZA', // Afrikaans (Afrique du Sud)
    AM_ET = 'am-ET', // Amharique (Éthiopie)
}
